<template>
  <div>
    <!-- v-if="status === 'DRAFT'" -->
    <a-badge
      count="Draft"
      :number-style="{
        backgroundColor: '#fff',
        color: '#999',
        boxShadow: '0 0 0 1px #d9d9d9 inset',
      }"
      v-if="status === 'DRAFT'"
    />
    <a-badge
      count="Submitting"
      :number-style="{
        backgroundColor: '#1890ff',
        color: '#fff',
      }"
      v-else-if="status === 'SUBMITTING'"
    />
    <a-badge
      count="Edditing"
      :number-style="{
        backgroundColor: '#fdc032',
        color: '#fff',
      }"
      v-else-if="status === 'EDITING'"
    />
    <a-badge
      count="Approved"
      v-else-if="status === 'APPROVED'"
      :number-style="{ backgroundColor: '#52c41a' }"
    />
    <a-badge count="Rejected" v-else-if="status === 'REJECTED'" />
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
